
import React, { useEffect ,useState} from "react";
import {connect} from 'react-redux';
import {getCourseOutcomeData,getCourseCurriculumData,getTermsData,getCurriculumData} from "../../../redux/actions/dataAction";
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomFilter from '../../../constants/CustomFilter';

const Course_Outcome = (props) => {
  useEffect(()=>{
    props.getCourseOutcomeData()
    props.getCourseCurriculumData()
    props.getTermsData()
    props.getCurriculumData()
  },[])
  const [filter,setFilter]=useState({
    term:'Select Term',
    curriculum:'Select Curriculum',
    course:'Select Course'
  })
  const handleChange=(event)=>{
    setFilter(({...filter,[event.target.id]:event.target.value})) 
  
  }
  const terms=[]
  for(var i=0;i<props?.terms?.data.length;i++){
    terms.push({value:props?.terms?.data[i].name})
  }
  const curriculums=[]
  for(var i=0;i<props?.curriculums?.data.length;i++){
    curriculums.push({value:props?.curriculums?.data[i].name})
  }
  

  const [filterCourseData,setFilterCourseData]=useState([]);
  const [filterData,setFilterData]=useState([]);
  const Filter=()=>{
    let term_data= CustomFilter(props?.course_curriculum?.data,[{value:filter.term,label:'term',initial_value:'Select Term'},{value:filter.curriculum,label:'curriculum',initial_value:'Select Curriculum'}]);
    let courses=[]
    for(var i=0;i<term_data?.length;i++){
      courses.push({value:term_data[i].domain})
    }
    setFilterCourseData([...courses])
 }
 const FilterTableData=()=>{
   let data=CustomFilter(props?.courseOutcome?.data,[{value:filter.course,label:'course',initial_value:'Select Course'}]);
   setFilterData(data);
 }

useEffect(()=>{
 Filter()
},[filter,props?.course_curriculum])
useEffect(()=>{
  FilterTableData()
},[props?.course_curriculum,filterCourseData])
  const columns = [ 
    {title: "CO Code",field:"code"},
    {title: "Course Outcome",field:"statement"},
    {title: "Blooms Level",field:"cognitive_domain"},
    {title: "Delivery Method",field:"delivery_method"},
    {title:'Created By',field:'created_by'},
  ]
  console.log(props?.courseOutcome?.data)
  return (
    <div className="customContainer">
    <CustomHeading title="Course OutCome (CO)"/>
    <div className="row">
    <div className="col-md-4">
    <CustomDropdown 
      label="Curriculum :"
      data={curriculums}
      defaultOption={'Select Curriculum'}
      notDefaultOption
      id={'curriculum'}
      onChange={handleChange}
      />
      </div>
       <div className="col-md-4">
      <CustomDropdown 
      label="Term :"
      data={terms}
      defaultOption={'Select Term'}
      notDefaultOption
      id={'term'}
      onChange={handleChange}
      />
      </div>
       <div className="col-md-4">
      <CustomDropdown 
      label="Course :"
      data={filterCourseData}
      defaultOption={'Select Course'}
      notDefaultOption
      id={'course'}
      onChange={handleChange}
      />
      </div>
    </div>
    <CustomTableWithAll data={filterData} title={"Course Outcome"} buttonRequired={true} buttonLabel="ADD" columns={columns} api="/api/Course-Outcome/" identify="CourseOutcome" />
  </div>
  );
};

const mapActionWithProps = {
  getCourseOutcomeData,
  getCourseCurriculumData,
  getTermsData,
  getCurriculumData,
}

const mapStateWithProps = (state)=>(
  {
    courseOutcome:state.data.courseOutcome,
    course_curriculum:state.data.course_curriculum,
    terms:state.data.terms,
    curriculums:state.data.curriculums,
  }
)
export default connect(mapStateWithProps,mapActionWithProps) (Course_Outcome);
